/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ProgressionsRoute extends Route {
  // Services
  @service
  store;

  model() {
    let store = this.store;
    let person = this.modelFor('people/person').person;
    let progressionType = ProgressionType.PROGRESSION;

    return hash({
      person,
      subjects: store.query('goals/subject', { trackable: true }),
      milestones: store.query('milestones/milestone', { progressionType }),
      milestoneSets: store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    model.subjects = model.subjects
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }
}
